<template>
    <icon-base width="25" height="25" viewBox="0 0 25 25">
        <path d="M5.93547 12.3189L10.9011 17.0823L18.8224 9.687" stroke="#00AF41" stroke-width="2"></path>
        <circle cx="12.5" cy="12.5" r="11.5" stroke="#00AF41" stroke-width="2"></circle>
    </icon-base>
</template>

<script>
    import IconBase from "../../IconBase";
    export default {
        name: 'icon-successful',
        components: {IconBase}
    }
</script>